<template>
    <div id="album-basic-card">
        <div class="vx-row">
            <h3 class="title">Favourite Albums</h3>
            <vs-divider/>
                <div v-if="favouriteList.length <= 3" class="vx-col w-full">
                    <div :data="albums" :key="indextr" v-for="(albums, indextr) in favouriteList" class="vx-col w-1/6 mb-base ml-base float-left">
                        <vx-card 
                            :title="albums.photobookName" 
                            :subtitle="albums.patientName"
                            title-color="#fff"
                            content-color="#fff"
                            card-background="rgba(160, 97, 106, 0.7)"
                            class="small-fv-cards">

                            <template slot="actions">
                                <feather-icon v-if="albums.isFavourite == 1" icon="HeartIcon" svgClasses="w-6 h-6 stroke-current text-fav-color" @click="confirmUpdation(albums.photolistID, 0)"></feather-icon>
                                <feather-icon v-else icon="HeartIcon" svgClasses="w-6 h-6 text-grey" @click="confirmUpdation(albums.photolistID, 1)"></feather-icon>
                            </template>
                            <img :src="albums.albumLogo" @click="viewPhotobook(albums.path)" alt="content-img" class="responsive rounded-lg">
                        </vx-card>
                    </div>
                </div>
                <swiper v-else :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl">
                    <swiper-slide :data="albums" :key="indextr" v-for="(albums, indextr) in favouriteList" class="vx-col w-1/6">      
                        <div class="vx-col w-full mb-base">
                            <vx-card 
                                :title="albums.photobookName" 
                                :subtitle="albums.patientName"
                                title-color="#fff"
                                content-color="#fff"
                                card-background="rgba(160, 97, 106, 0.7)"
                                class="small-fv-cards">

                                <template slot="actions">
                                    <feather-icon v-if="albums.isFavourite == 1" icon="HeartIcon" svgClasses="w-6 h-6 stroke-current text-fav-color" @click="confirmUpdation(albums.photolistID, 0)"></feather-icon>
                                    <feather-icon v-else icon="HeartIcon" svgClasses="w-6 h-6 text-grey" @click="confirmUpdation(albums.photolistID, 1)"></feather-icon>
                                </template>
                                <img :src="albums.albumLogo" @click="viewPhotobook(albums.path)" alt="content-img" class="responsive rounded-lg">
                            </vx-card>
                        </div>
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
        
        </div>        
        <div class="vx-row">
            <h3 class="title">Nursing Home Albums</h3>
            <vs-divider/>
            <div id="data-list-list-view" class="data-list-container vx-col w-full">
                <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="albumList">

                    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                        <!-- ITEMS PER PAGE -->
                        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ albumList.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : albumList.length }} of {{ queriedItems }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=4">
                            <span>4</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=10">
                            <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=15">
                            <span>15</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                            <span>20</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>

                    <template slot="thead">
                        <vs-th>
                            <feather-icon icon="FilmIcon" svgClasses="w-6 h-6 text-black ml-10"></feather-icon>
                        </vs-th>
                        <vs-th sort-key="photobookName">Name</vs-th>
                        <vs-th sort-key="patientName">Patient Name</vs-th>
                        <vs-th sort-key="isFavourite">Favourite</vs-th>	    
                        <!-- <vs-th>Action</vs-th> -->
                    </template>

                    <template slot-scope="{data}">
                        <tbody>
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                            <vs-td>
                                <div @click="viewPhotobook(tr.path)" class="table-img-thumb">
                                 <img :src="tr.albumLogo" alt="content-img" class="responsive rounded-lg">
                                </div>
                            </vs-td>
                            <vs-td>
                                <p class="font-medium truncate">{{ tr.photobookName }}</p>
                            </vs-td>
                            <vs-td>
                                <p>{{ tr.patientName | title }}</p>
                            </vs-td>

                            <vs-td>
                                <feather-icon v-if="tr.isFavourite == 1" icon="HeartIcon" svgClasses="w-6 h-6 fill-current text-fav-color" @click="confirmUpdation(tr.photolistID, 0)"></feather-icon>
                                <feather-icon v-else icon="HeartIcon" svgClasses="w-6 h-6 text-grey" @click="confirmUpdation(tr.photolistID, 1)"></feather-icon>
                            </vs-td>
                            </vs-tr>
                        </tbody>
                    </template>
                </vs-table>
            </div>

        </div>
    </div>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default{
  components: {
    VuePerfectScrollbar,
    swiper,
    swiperSlide
  },
  data () {
    return {
      fillColor: '#FF9797',
      albumList: [],
      itemsPerPage: 4,
      isMounted: false,
      favouriteList: [],
      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 30
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20
          }
        }
      },        
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  computed: {
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
  
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.albumList.length
    }
  },
  created () {
    // all albums
    this.getAlbumData()
  },
  mounted () {
    this.isMounted = true
  },
  methods: {
    getAlbumData () {
      this.$vs.loading()
      this.$http.get('/nh/staff-collection/')
        .then((response) => { this.$vs.loading.close(); this.albumList = response.data.data })
        .catch((error)   => { 
          console.log(error)
          this.$vs.notify({title:'Something went wrong!', text:'Please try after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
        })
        // favourite albums
      this.$http.get('nh/favourite-collection/')
        .then((response) => { this.$vs.loading.close(); this.favouriteList = response.data.data })
        .catch((error)   => { 
          console.log(error)
          this.$vs.notify({title:'Something went wrong!', text:'Please try after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
          this.$vs.loading.close()
        })
    }, 
    viewPhotobook (viewPath) {
      //let public_url = 'http://167.172.238.237:8002/share-view-photobook/'+ bookID +'/'
      window.open(viewPath, '_blank')
    }, 
    confirmUpdation (bookID, fav_val) {
      if (fav_val == 0) {  
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Are you sure ?',
          text: 'Remove this album from favorite list ?',
          accept: this.updateFavorite,
          acceptText: 'Remove',
          parameters: [bookID, fav_val]
        })
      } else {  
        this.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: 'Are you sure ?',
          text: 'Add this album to favorite list ?',
          accept: this.updateFavorite,
          acceptText: 'Add',
          parameters: [bookID, fav_val]
        })
      }
        
      return true
    },
    updateFavorite (data) {
      this.$vs.loading()
      if (data[1] == 0) {
        this.$http.delete('nh/favourite-collection/', {data: { photolistID: data[0] }})
          .then((response) => { 
            this.$vs.loading.close() 
            if (response.data.messageType == 'success') {        
              this.$vs.notify({title:'Great!', text:response.data.message, color:'success', position:'top-right', icon:'check_box', time:5000})
              return this.getAlbumData()
            } else {

              this.$vs.notify({title:'Attention!', text:response.data.message, color:'warning', position:'top-right', icon:'error', time:5000})
              return this.getAlbumData()
            }         
          })
          .catch((error)   => { 
            console.log(error)
            this.$vs.notify({title:'Something went wrong!', text:'Please try after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
            this.$vs.loading.close()
          })
      } else {
        const formData = new FormData()
		    formData.append('photolistID', data[0])
        this.$http.post('nh/favourite-collection/', formData, { headers: {'Content-Type': 'multipart/form-data' }})
          .then((response) => { 
            this.$vs.loading.close() 
            if (response.data.messageType == 'success') {        
              this.$vs.notify({title:'Great!', text:response.data.message, color:'success', position:'top-right', icon:'check_box', time:5000})
              return this.getAlbumData()
            } else {

              this.$vs.notify({title:'Attention!', text:response.data.message, color:'warning', position:'top-right', icon:'error', time:5000})
              return this.getAlbumData()
            }         
          })
          .catch((error)   => { 
            console.log(error)
            this.$vs.notify({title:'Something went wrong!', text:'Please try after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
            this.$vs.loading.close()
          })
      }
       
    }
  }
}
</script>
<style lang="scss">
.small-fv-cards .vx-card__title h4 { font-size: 13px;}
.small-fv-cards .vx-card__title h6 { font-size: 12px;}
.small-fv-cards .vx-card__header .vx-card__actions{
    width: 100%;
    text-align: center;
    padding: 14px 0 0 0;
}
.text-fav-color{ color: #FF9797; }

#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
    .table-img-thumb {
        width: 80px;
    }
}
</style>
